// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/sass/app.scss
// module id = 488
// module chunks = 19